module.exports = "/assets/data/619ca9ec86daa34b3fc4be3fd42f1fa3-W1W.data.json";